import * as React from "react";
//import { graphql, useStaticQuery } from "gatsby";

const Seo = ({ title }: {title: string}) => {
  
  return (
    <title>
      {title === "" ? (`Jeremy King | NetizenKing`) : (`${title} | Jeremy King | NetizenKing`)}
    </title>
  );
};

export default Seo;
